import { HTMLAttributes } from "react";
import styled from 'styled-components';


type BtnProp = {
    onClick: () => void
}

export const XBtn = ({onClick}:BtnProp) => {

    const imgUrl = process.env.PUBLIC_URL + `/x.svg`

    return (
    <XBtnContainer onClick={onClick}>
        <img src={imgUrl} />
    </XBtnContainer>
    )
}

const XBtnContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
`



export const BackBtn = ({onClick}:BtnProp) => {

    const imgUrl = process.env.PUBLIC_URL + `/back.svg`

    return (
    <BackBtnContainer onClick={onClick}>
        <EmtpyBox width={1} />
        <img src={imgUrl} />
    </BackBtnContainer>
    )
}

const BackBtnContainer = styled.div`
    position: absolute;
    left: 10px;
`


const Textfleid = styled.input`

font-size: 16px;
padding: 10px; 
width: 262px;
height: 41px;
background: #D9D9D9; 
border-radius: 20px;
border-color: #D9D9D9;

&:hover{
    border-color: #D9D9D9;
    outline: #4F8FFB;

}
`

interface EmtpyBoxProps extends HTMLAttributes<HTMLDivElement> {
    width?: number;
    height?: number;
}

export const EmtpyBox = styled.div<EmtpyBoxProps>`
  width: ${({ width }) => (width ? `${width}vw` : "0")};;
  height: ${({ height }) => (height ? `${height}vw` : "0")};;
`

interface MarginBoxProps extends HTMLAttributes<HTMLDivElement> {
    right?: number;
    top?: number;
    left?: number;
    bottom?: number;
};

export const MarginBox = styled.div<MarginBoxProps>`
  width: 100%;
  height: 100%;
  margin-right: ${({ right }) => (right ? `${right}vw` : "0")};
  margin-top: ${({ top }) => (top ? `${top}vh` : "0")};
  margin-left: ${({ left }) => (left ? `${left}vw` : "0")};
  margin-bottom: ${({ bottom }) => (bottom ? `${bottom}vh` : "0")};
`;

interface PaddingBoxProps extends HTMLAttributes<HTMLDivElement> {
    right?: number;
    top?: number;
    left?: number;
    bottom?: number;
};

export const PaddingBox = styled.div<PaddingBoxProps>`
    padding-right: ${({ right }) => (right ? `${right}vw` : "0")};
    padding-top: ${({ top }) => (top ? `${top}vh` : "0")};
    padding-left: ${({ left }) => (left ? `${left}vw` : "0")};
    padding-bottom: ${({ bottom }) => (bottom ? `${bottom}vh` : "0")};
`;



interface AlignBoxProps extends HTMLAttributes<HTMLDivElement> {
    justify?: "top" | "bottom" | "center";
    align?: "left" | "right" | "center";
    direction?: "row" | "column";
    flex?: number;
};



export const AlignBox = styled.div<AlignBoxProps>`
  width: 100%;
  display: flex;
  flex: ${({ flex }) => flex || 1};
  flex-direction: ${({ direction }) => direction || "column"};
  justify-content: ${({ justify }) =>
        justify === "top"
            ? "flex-start"
            : justify === "bottom"
                ? "flex-end"
                : "center"};
  align-items: ${({ align }) =>
        align === "left"
            ? "flex-start"
            : align === "right"
                ? "flex-end"
                : "center"};
  text-align: ${({ align }) =>
        align === "left"
            ? "left"
            : align === "right"
                ? "right"
                : "center"};
`;

export {Textfleid}